// @ts-nocheck
import axios from 'axios'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {App} from "@vue/runtime-core";
import {Router} from "vue-router";
import {Notify, Toast} from "vant";
import router from "@/router";
import { getCurrentEnv, envBackHandler } from "@/utils/envBack";
// axios.defaults.baseURL = process.env.VUE_APP_API_ADDRESS;
// axios.defaults.headers.withCredentials = true;
/**
 * axios插件安装方法
 */
export default function (app: App) {
  axios.interceptors.request.use(
    config => {
        console.log(9999,config)
      NProgress.start()
     /* let rememberMe = localStorage.getItem("rememberMe")
      let sid = localStorage.getItem("sid")
      // 配置请求凭证
      if (rememberMe!=null&& sid!=null) {
        config.headers.rememberMe = rememberMe
        config.headers.sid = sid
      }*/
      config.headers['Cache-Control'] = 'no-cache'
      config.headers['clientId'] = sessionStorage.getItem('clientId') || ''
      return config
    },
    error => {
      NProgress.done()
      Notify({type: 'danger', message: error.message});
      throw new Error(error.message)
    }
  )

  axios.interceptors.response.use(
    response => {
        console.log(8888,response)
      NProgress.done()
      // 未认证
      if (response?.status === 401 || response?.data?.code === 1001) {
        if (getCurrentEnv()) {
          envBackHandler()
        } else {
          Toast({type: 'danger', message: "无权限"})
        }
       /* // 跳转到登录页面
        (app.config.globalProperties.$router as Router).push("/loginPrescription");*/
      }
      if (response?.data?.code !== 0 && response?.config?.url.includes('/api/activity/auth/login')) {
        Toast({type: 'danger', message: response.data.message || ''})
      }
      // 文件下载
      if (response.request.responseType === 'blob') {
        return response
      }
      if (response.status === 200) {
        return response.data;
      }
    },
    error => {
        if(error.response.config.url.includes('/api/healthc') ){
            router.push('/pingweiService/userLogin')
        }else{
            Notify({type: 'danger', message: error.message});
        }
      NProgress.done()
      throw new Error(error.message)
    }
  )
}
